import React, { Component } from 'react'
import Card from '../Components/Card'
import AnchorLink from 'react-anchor-link-smooth-scroll'


export default class About extends Component {
    render() {
        return (
            <div> 
                <Card />
                <div>
                <section id='things'>
                       <h2>Things</h2>
                     </section>
                     <section id='stuff'>
                       <h2>Stuff</h2>
                     </section>
                </div>
                <div>
                     <AnchorLink href='#over'>Things</AnchorLink>
                     <AnchorLink href='#stuff'>Stuff</AnchorLink>
                </div>
            </div>
        )
    }
}
